import React, {
  Fragment, useContext, useState
  // useCallback, useState
} from "react";
import { ApiContext } from "../context/ApiContext";
import { Link } from "react-router-dom";
import {
  Button,
  // makeStyles
} from "@material-ui/core";
import { useCookies } from "react-cookie";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemButton,
} from 'react-accessible-accordion';
import { SnackbarContext } from "../context/SnackbarContext";
import Header from "../components/Header";
import Leftnav from "../components/Leftnav";
import Appfooter from "../components/Appfooter";
import { makeStyles } from "@material-ui/core/styles";
import AdsModal from "../components/AdsModal";
import { useTranslation } from 'react-i18next';
import i18n from '../i18n'; 



const HowTo= () => {
  const {
    profile,
    //  editedProfile, setEditedProfile, deleteProfile, setCover, coverBack, createProfile, editProfile
  } = useContext(ApiContext);

  const [cookies, setCookie, removeCookie] = useCookies(["current-token"]);
  const Logout = () => {
    localStorage.removeItem('current-token'); 
    window.location.replace("/login");
  };
  const { newSnack } = useContext(SnackbarContext);

  const [language, setLanguage] = useState(i18n.language);

  

  const useStyles = makeStyles((theme) => {
    return {
      root: {
        marginTop: 30,
        minWidth: "100%",
        display: "flex",
        alignItems: "center",
        textAlign: "center",
        flexFlow: "column",
        "& .file-upload-container": {
          width: 500,
          marginTop: 10,
          "& .button": {
            backgroundColor: "#00A0FF",
            color: "white",
          },
        },
      },
      validationWrapper: {
        float: "right"
      }
    }
  })

  const [isShowAdsModal, setShowAdsModal] = useState(false);

  const handleAdsClick = () => {
    if (!profile.userProfile) {
      newSnack("error", t('HowTo19'));
      return;
    }
    setShowAdsModal(true);
  }
  const handleModalClose = () => {
    setShowAdsModal(false);
  }
  const { t } = useTranslation();

  const BOOKMARKLET =
  "javascript:(()=>{const u=encodeURIComponent(location.href);location.href='https://nicelinks.net/post-intent?url='+u;})();";

const copyBookmarklet = async () => {
  try {
    await navigator.clipboard.writeText(BOOKMARKLET);
    newSnack("success", "ブックマークレットをコピーしました。Safariで新規ブックマークのURL欄に貼り付けてください。");
  } catch {
    newSnack("error", "コピーできませんでした。長押しして『リンクをコピー』をお試しください。");
  }
};

  return (
<Fragment>
    <Header />
    <Leftnav />
    <div className="main-content bg-lightblue theme-dark-bg right-chat-active">
    <AdsModal
        isVisible={isShowAdsModal}
        handleClose={handleModalClose}
      />
      <div className="middle-sidebar-bottom">
        <div className="middle-sidebar-left">
          <div className="middle-wrap">
            <div className="card w-100 border-0 bg-white shadow-xs p-0 mb-4">
              <div className="card-body p-4 w-100 bg-current border-0 d-flex rounded-3">
                <Link to="/settings" className="d-inline-block mt-2">
                  <i className="ti-arrow-left font-sm text-white"></i>
                </Link>
                <h4 className="font-xs text-white fw-600 ms-4 mb-0 mt-2">
                {t('HowTo1')}
                </h4>
              </div>

              <div className="card mt-2 w-100 border-0 p-0 rounded-3 overflow-hidden bg-image-contain bg-image-center " 
              style={{backgroundImage: `url("assets/images/background_advertisement.jpg")`}}>
                  <div className="card-body p-md-5 p-4 text-center" style={{backgroundColor:'rgba(71,120,79,0.8)'}}>
                      <h2 className="fw-700 display2-size text-white display2-md-size lh-2">{t('HowTo2')}</h2>
                      <p className="font-xsss ps-lg-5 pe-lg-5 lh-28 text-grey-200">{t('HowTo3')}</p>
                  </div>
              </div>

              <div className="card w-100 shadow-xss rounded-xxl border-0 p-4 mb-3">
              <div className="col-xl-8 col-xxl-9 col-lg-8">
                        <img src="assets/images/ad_2.png" alt="" className="rounded-3 img-fluid w-100" />
                      </div>

              {/* <div className="card-body p-0 mb-3 rounded-3 overflow-hidden uttam-die">
                {
                  language&&language === "en"?
                  <video autoPlay loop className="float-right w-100">
                            <source src={`assets/images/welcome_video.mp4`} type="video/mp4" />
                        </video>
                    :
                  <video autoPlay loop className="float-right w-100">
                            <source src={`assets/images/welcome_video.mp4`} type="video/mp4" />
                        </video>

                }

                </div> */}

                  <Accordion allowZeroExpanded className="accodion-style--1 accordion" preExpanded={'0'}>
                      <AccordionItem className="card shadow-xss">
                          <AccordionItemHeading className="card-header">
                              <AccordionItemButton>
                                  <h5 className="fw-600 pt-2 pb-2 mb-0">{t('HowTo4')}</h5>
                              </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel className="card-body">
                          <p>{t('HowTo5')}</p>
                          {/* <div className="card-body p-0 mb-3 rounded-3 overflow-hidden uttam-die">
                          {
                            <video autoPlay loop className="float-right w-100">
                                      <source src={`assets/images/howto_video_data.mp4`} type="video/mp4" />
                                  </video>
                          }
                          </div> */}

                          <Link to="/home">
                          <span
                            className="pointer font-xsssss fw-700 ps-3 pe-3 pt-2  lh-32 text-uppercase rounded-3 ls-2 bg-gold-gradiant  text-white shadow-sm w-100 mt-2 d-flex"
                          >
                            <i className="feather-chevrons-right text-white font-xss"></i>
                            <h4 className="font-xssss text-white fw-600">
                            {t('HowTo6')}
                            </h4>
                            
                          </span>
                          </Link>
                          </AccordionItemPanel>

                      </AccordionItem>
                      <AccordionItem className="card shadow-xss">
                          <AccordionItemHeading className="card-header">
                              <AccordionItemButton>
                                  <h5 className="fw-600 pt-2 pb-2 mb-0">{t('HowTo7')}</h5>
                              </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel className="card-body">
                          <p>{t('HowTo8')}</p>
                          <div className="col-xl-8 col-xxl-9 col-lg-8">
                            <div className="pe-2">
                          
                            {/* <div className="card-body p-0 mb-3 rounded-3 overflow-hidden uttam-die">
                          {
                            <video autoPlay loop className="float-right w-100">
                                      <source src={`assets/images/howto_video_find.mp4`} type="video/mp4" />
                                  </video>
                          }
                          </div> */}
                            </div>
                          </div>
                          <Link to="/postsearch">
                          <span
                            className="pointer font-xsssss fw-700 ps-3 pe-3 pt-2  lh-32 text-uppercase rounded-3 ls-2 bg-gold-gradiant  text-white shadow-sm w-100 mt-2 d-flex"
                          >
                            <i className="feather-chevrons-right text-white font-xss"></i>
                            <h4 className="font-xssss text-white fw-600">
                            {t('HowTo9')}
                            </h4>
                            
                          </span>
                          </Link>
                          </AccordionItemPanel>
                      </AccordionItem>
                      <AccordionItem className="card shadow-xss">
                          <AccordionItemHeading className="card-header">
                              <AccordionItemButton>
                                  <h5 className="fw-600 pt-2 pb-2 mb-0">{t('HowTo10')}</h5>
                                  
                            
                          
                              </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel className="card-body">
                          <p>{t('HowTo11')}</p>
                          <div className="col-xl-8 col-xxl-9 col-lg-8">
                          {/* <div className="pe-2">
                          
                          {
                            <video autoPlay loop className="float-right w-100">
                                      <source src={`assets/images/howto_video_get.mp4`} type="video/mp4" />
                                  </video>
                          }
                            </div> */}
                            </div>
                            <Link to="/usersearch">
                          <span
                            className="pointer font-xsssss fw-700 ps-3 pe-3 pt-2  lh-32 text-uppercase rounded-3 ls-2 bg-gold-gradiant  text-white shadow-sm w-100 mt-2 d-flex"
                          >
                            <i className="feather-chevrons-right text-white font-xss"></i>
                            <h4 className="font-xssss text-white fw-600">
                            {t('HowTo12')}
                            </h4>
                            
                          </span>
                          </Link>
                          </AccordionItemPanel>
                      </AccordionItem>

                      {/* ▼▼▼ ここから追加：iOS / Safari 共有（ブックマークレット） ▼▼▼ */}
<AccordionItem className="card shadow-xss">
  <AccordionItemHeading className="card-header">
    <AccordionItemButton>
      <h5 className="fw-600 pt-2 pb-2 mb-0">iOS（Safari）からNicelinksにシェアする</h5>
    </AccordionItemButton>
  </AccordionItemHeading>
  <AccordionItemPanel className="card-body">
    <p className="mb-3">
      iOSのSafariはWeb Share Targetに未対応のため、<b>ブックマークレット</b>で同等の体験を提供します。
      以降、Safariで任意のページを開いてこのブックマークを実行すると、Nicelinksの投稿モーダルが
      自動で開き、<code>URL</code>が入力された状態になります。
    </p>

    <ol className="mb-3">
      <li>下の<b>コピー</b>を押してブックマークレットをコピー</li>
      <li>Safariで任意のページを開き、<b>共有</b> → <b>ブックマークを追加</b></li>
      <li>ブックマーク編集で<b>URL欄を全選択して貼り付け</b>（タイトルは「Nicelinksで共有」など）</li>
      <li>以後、共有したいページでそのブックマークを実行</li>
    </ol>

    <div className="d-flex align-items-center p-2 rounded bg-light" style={{gap: 8}}>
      <input
        readOnly
        className="form-control font-xssss"
        value={BOOKMARKLET}
        onFocus={(e)=>e.currentTarget.select()}
      />
      <Button
        className="bg-current text-white font-xsss fw-600"
        variant="contained"
        onClick={copyBookmarklet}
      >
        コピー
      </Button>
    </div>

    <div className="mt-3">
      <small className="text-grey-600">
        ※ 長押しで「リンクをコピー」してもOKです。ホーム画面アプリ（PWA）でも同様に動作します。
      </small>
    </div>
  </AccordionItemPanel>
</AccordionItem>
{/* ▲▲▲ 追加ここまで ▲▲▲ */}


                      
                      {/* <AccordionItem className="card shadow-xss">
                          <AccordionItemHeading className="card-header">
                              <AccordionItemButton>
                                  <h5 className="fw-600 pt-2 pb-2 mb-0">{t('HowTo16')}</h5>
                              </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel className="card-body">
                              <p>{t('HowTo17')}</p>
                              <div className="col-xl-8 col-xxl-9 col-lg-8">
                            <div className="pe-2">
                          
                              <img
                                src="assets/images/howto_ad.png"
                                alt="avater"
                                className="rounded-3 img-fluid w-100"
                              />
                            </div>
                          </div>
                          <Link to="/adapplication">
                          <span
                            className="pointer font-xsssss fw-700 ps-3 pe-3 pt-2  lh-32 text-uppercase rounded-3 ls-2 bg-gold-gradiant  text-white shadow-sm w-100 mt-2 d-flex"
                          >
                            <i className="feather-chevrons-right text-white font-xss"></i>
                            <h4 className="font-xssss text-white fw-600">
                            {t('HowTo18')}
                            </h4>
                            
                          </span>
                          </Link>
                          </AccordionItemPanel>
                      </AccordionItem> */}


                  </Accordion>
              </div>

              {/* <div className="card-body p-lg-5 p-4 w-100 border-0">
              <div className="row justify-content-center mb-4">

                <div className="col-lg-12 text-center">
                  <Button
                    className="bg-current text-center text-white font-xsss fw-600 p-3 w175 rounded-3 ms-1 me-1 mt-3"
                    variant="contained"
                    component="label"
                    onClick={handleAdsClick}
                  >
                    新規広告を出稿
                  </Button>
                  <Link to="/userpage">
                  <Button
                    className="bg-current text-center text-white font-xsss fw-600 p-3 ms-1 me-1 w175 rounded-3 mt-3"
                    variant="contained"
                    component="label"
                  >
                    出稿済み広告を確認
                  </Button>
                  </Link>
                </div>
              </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Appfooter />
    </Fragment>
  );
};

export default HowTo;
